
export const peScrollIntoView = (search: string, block?: ScrollLogicalPosition) => {
  const targetSection = document.querySelector<HTMLInputElement>(search);
  if (targetSection) targetSection.scrollIntoView({ behavior: 'smooth', block: block ? block : 'end' });
}